import * as React from 'react';

import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';
import { ListingEntry } from '../../components/ListingEntry';
import { selectListingsUrls } from '../../selectors/listingsUrls';
import { selectIsStickyButtonShown } from '../../selectors/stickyButton';

export const ListingEntryContainer: React.FC = () => {
  const { listingUrl } = useSelector(selectListingsUrls);
  const isShown = useSelector(selectIsStickyButtonShown);

  if (!listingUrl) {
    return null;
  }

  return (
    <Responsive phone tablet>
      <ListingEntry listingUrl={listingUrl} isShown={isShown} />
    </Responsive>
  );
};
